import { graphqlUrl, RequestOptions, xmlHttpRequest } from "./request-shared";

export function getPromise<T=unknown, R=T>(
	url:string,
	mapData:(data:T)=>R=(data=>data as unknown as R),
	options:RequestOptions={},
): Promise<R>{
	return new Promise<R>(resolve=>{
		xmlHttpRequest<T>({
			...options,
			url,
			method: 'get',
			success: data=>resolve(mapData(data)),
			failure: ()=>resolve(null),
		});
	});
}

export function postPromise<T=unknown, R=T>(
	url:string,
	body:{}|FormData|Blob|null,
	mapData:(data:T)=>R=(data=>data as unknown as R),
	options:RequestOptions={},
	): Promise<R>{
	return new Promise<R>((resolve,reject)=>{
		xmlHttpRequest<T>({
			...options,
			url,
			method: 'post',
			body,
			success: data=>resolve(mapData(data)),
			failure: (err)=>reject(err),
		});
	});
}

export function putPromise<T=unknown, R=T>(
	url:string,
	body:{}|FormData|Blob|null,
	mapData:(data:T)=>R=(data=>data as unknown as R),
	options:RequestOptions={},
	): Promise<R>{
	return new Promise<R>(resolve=>{
		xmlHttpRequest<T>({
			...options,
			url,
			method: 'put',
			body,
			success: data=>resolve(mapData(data)),
			failure: ()=>resolve(null),
		});
	});
}

export function deletePromise<T=unknown, R=T>(
	url:string,
	mapData:(data:T)=>R=(data=>data as unknown as R),
	options:RequestOptions={},
):Promise<R>{
	return new Promise<R>(resolve=>{
		xmlHttpRequest<T>({
			...options,
			url,
			method: 'delete',
			success: data=>resolve(mapData(data)),
			failure: ()=>resolve(null),
		});
	});
}

export function graphqlPromise<T=unknown, R=T>(
	operationName:string,
	query:string,
	variables:object,
	mapData:(data:T)=>R=(data=>data as unknown as R),
	options:RequestOptions={},
): Promise<R>{
	const body={
		operationName,
		query,
		variables,
	};
	return new Promise<R>(resolve=>{
		xmlHttpRequest<T>({
			...options,
			url: graphqlUrl,
			method: 'post',
			body,
			success: data=>resolve(mapData(data)),
			failure: ()=>resolve(null),
		});
	});
}
